<template>
    <v-container tag="section">
        <v-row>
            <v-col class="pt-3 pt-sm-8 pb-6 pb-sm-8">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="py-0">
                <v-btn-toggle tile mandatory class="map-buttons" v-model="mapFilter">
                    <v-btn height="auto" tile outlined @click="updateMap($event, 'testing')" class="py-6 px-4 px-sm-8 py-sm-8">
                        <img v-if="mapFilter === 0" class="mr-3" src="@/assets/icons/map-pin-blue.svg" alt=""/>
                        <img v-else class="mr-3" src="@/assets/icons/map-pin-grey.svg" alt=""/>
                        <span>{{ mapConfig.mapTab1Header }}</span>
                    </v-btn>
                    <v-btn height="auto" tile outlined @click="updateMap($event, 'facility')" class="py-6 px-4 px-sm-8 py-sm-8">
                        <img v-if="mapFilter === 1" class="mr-3" src="@/assets/icons/map-pin-blue.svg" alt=""/>
                        <img v-else class="mr-3" src="@/assets/icons/map-pin-grey.svg" alt=""/>
                        <span>{{ mapConfig.mapTab2Header }}</span>
                    </v-btn>
                </v-btn-toggle>
                <div id="map-buttons"></div>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pt-0">
                <div id="map"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import mapboxgl from 'mapbox-gl';

    export default {
        props: [
            'label'
        ],
        data: () => ({
            mapFilter: '',
            mapPin: require('@/assets/icons/map-pin@2x.png'),
            mapPinGreen: require('@/assets/map-green/map-locator.png'),
            mapPinRed: require('@/assets/map-red/map-locator.png')
        }),
        computed: {
            mapConfig() {
                return this.$store.getters.getMapConfig
            }
        },
        methods: {
            updateMap(event, type) {
                if(type === 'testing') {
                    document.querySelector('#type-1').click()
                    document.querySelector('#type-2').click()
                } else if(type === 'facility') {
                    document.querySelector('#type-1').click()
                    document.querySelector('#type-2').click()
                }
            }
        },
        mounted() {
            var that = this;
            var filterGroup = document.getElementById('map-buttons');

            mapboxgl.accessToken = this.mapConfig.mapAPIKey;

            const map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/rbosch/ck8cdqvlo2k6r1ik9u6p59cn8',
                center: that.mapConfig.mapCenter,
                zoom: that.mapConfig.mapZoomLevel,
                scrollZoom: {
                    ctrl: true
                }
            });

            map.on("wheel", event => {
                if (event.originalEvent.ctrlKey) {
                    return;
                }

                if (event.originalEvent.metaKey) {
                    return;
                }

                if (event.originalEvent.altKey) {
                    return;
                }

                event.preventDefault();
            });

            if(window.innerWidth < 600) {
                map.dragPan.disable();
            }

            map.addControl(new mapboxgl.NavigationControl());

            map.on('load', function() {

                map.loadImage(that.mapPin, function(error, image) {
                    if (error) throw error;
                    map.addImage('marker', image);
                });

                map.loadImage(that.mapPinGreen, function(error, image) {
                    if (error) throw error;
                    map.addImage('open', image);
                });

                map.loadImage(that.mapPinRed, function(error, image) {
                    if (error) throw error;
                    map.addImage('closed', image);
                });

                map.addSource('locations', {
                    type: 'geojson',
                    data: that.$store.getters.getMapData
                });

                that.$store.getters.getMapData.features.forEach(function(feature) {
                    var symbol = feature.properties['type'];
                    var state = feature.properties['state'];
                    var layerID = 'type-' + symbol;
                    
                    // Add a layer for this symbol type if it hasn't been added already.
                    if (!map.getLayer(layerID)) {
                        map.addLayer({
                            'id': layerID,
                            'type': 'symbol',
                            'source': 'locations',
                            'layout': {
                                // 'icon-image': 'marker',
                                'icon-image': ["match",["get","state"],["open"],"open",["closed"],"closed", "marker"],
                                'icon-allow-overlap': true
                            },
                            'filter': ['==', 'type', symbol]
                        });
                        
                        // Add checkbox and label elements for the layer.
                        var input = document.createElement('input');
                        input.type = 'checkbox';
                        input.id = layerID;
                        input.checked = input.id === 'type-1' ? true : false;
                        filterGroup.appendChild(input);
                        
                        var label = document.createElement('label');
                        label.setAttribute('for', layerID);
                        label.textContent = symbol === 1 ? "1" : "2";
                        filterGroup.appendChild(label);
                        
                        // When the checkbox changes, update the visibility of the layer.
                        input.addEventListener('change', function(e) {
                            map.setLayoutProperty(
                                layerID,
                                'visibility',
                                e.target.checked ? 'visible' : 'none'
                            );
                        });

                        map.setLayoutProperty(
                            layerID,
                            'visibility',
                            input.checked ? 'visible' : 'none'
                        );
                    }

                    map.on('click', layerID, function(e) {
                        var coordinates = e.features[0].geometry.coordinates.slice();
                        var title = e.features[0].properties.title,
                            state = e.features[0].properties.state,
                            description = e.features[0].properties.description;

                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }
                        
                        new mapboxgl.Popup()
                            .setLngLat(coordinates)
                            .setHTML('<h4> ' + title + '</h4><p class="state">' + state + '</p>' + '<p class="description">' + description + '</p>')
                            .addTo(map);
                    });

                    map.on('mouseenter', layerID, function() {
                        map.getCanvas().style.cursor = 'pointer';
                    });
                        
                    // Change it back to a pointer when it leaves.
                    map.on('mouseleave', layerID, function() {
                        map.getCanvas().style.cursor = '';
                    });
                });
            });
        }
    }
</script>

<style lang="scss">
    #map {
        height: 500px;
        position: relative;

        .mapboxgl-popup-content {
            border-radius: 6px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
            background-color: #ffffff;
            padding: 15px 17px;

            h4 {
                font-size: 14px;
                font-weight: 600;
                font-family: 'Montserrat', sans-serif;
                margin-bottom: 5px;
            }

            .mapboxgl-popup-close-button {
                display: none;
            }

            .description {
                // opacity: 0.5;
                font-size: 10px;
                font-weight: 500;
                font-family: 'Montserrat', sans-serif;
                margin-bottom: 0;
            }

            .state {
                opacity: 0.5;
                font-size: 10px;
                font-weight: 500;
                font-family: 'Montserrat', sans-serif;
                margin-bottom: 5px;
            }
        }
    }

    #map-buttons {
        display: none;
    }

    .marker {
        background-image: url('/img/mapbox-icon.png');
        background-size: cover;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;
    }

    .map-buttons {
        width: 100%;
        text-align: left;

        .v-btn-toggle > .v-btn.v-btn {
            opacity: 1;
        }

        .v-btn {
            flex: 1 1 auto;
            white-space: unset;
        }

        .v-btn__content {
            justify-content: flex-start;
            font-size: 18px;
            font-weight: 600;
            text-transform: none;
            flex: 1 1 auto;
            color: black;
            max-width: 100%;
            text-align: left;

            span {
                display: inline-block;
                max-width: 100%;
            }
        }

        .v-btn--active {

            span {
                text-decoration: underline;
            }
        }
    }

    .map-buttons.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
        border-bottom: solid 8px #a9a9a9!important;
        border-bottom-color: #a9a9a9!important;
        background-color: white;

    }

    .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before, .theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before{
        opacity: 0;
    }

    .map-buttons.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn.v-btn--active {
        border-bottom: solid 8px var(--v-local-base)!important;

        .v-icon {
            color: var(--v-local-base);
        }
    }
</style>
